import { createSlice } from "@reduxjs/toolkit";
import {
  weWorkData,
  WeWorkInitialStatus,
} from "../../../../../types/webCms/aboutUs/weWork";
import { getAllWeeWorkAsync, updateWeWorkAsync } from "./weWorkApi";

const initialState: WeWorkInitialStatus<weWorkData> = {
  loading: false,
  manageLoading: false,
  weWorkDataList: [],
  countWeWorkData: 0,
};

const weWorkSlice = createSlice({
  name: "admin-weWork",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    // get all
    builder
      .addCase(getAllWeeWorkAsync.pending, (state, action) => {
        state.loading = true;
      })
      .addCase(getAllWeeWorkAsync.fulfilled, (state, action) => {
        state.loading = false;
        state.weWorkDataList = action.payload.data;
        state.countWeWorkData = action.payload.length;
      })
      .addCase(getAllWeeWorkAsync.rejected, (state) => {
        state.loading = false;
        state.weWorkDataList = [];
        state.countWeWorkData = 0;
      });

    // update
    builder
      .addCase(updateWeWorkAsync.pending, (state) => {
        state.manageLoading = true;
      })
      .addCase(updateWeWorkAsync.fulfilled, (state) => {
        state.manageLoading = false;
      })
      .addCase(updateWeWorkAsync.rejected, (state) => {
        state.manageLoading = false;
      });
  },
});

export default weWorkSlice;
